import React from 'react';
// eslint-disable-next-line no-restricted-imports
import {css, tokens, useTokenValue, Drawer as SailDrawer} from '@sail/ui';
import {MIN_WIDTH} from '../../utils/Responsive/breakpoints';
import type {OverlayContentProps} from './Overlay';

export const Drawer: React.FC<OverlayContentProps> = ({
  children,
  handleClose,
  size,
  dataTestId,
  hasWhiteBackground,
  confirmCloseMessages,
}): JSX.Element => {
  const whiteBackground = useTokenValue(tokens.color.neutral[0]);

  return (
    <SailDrawer
      onClose={handleClose}
      size={size}
      uses={[
        css({
          ...(hasWhiteBackground ? {backgroundColor: whiteBackground} : {}),
          maxWidth: '100vw', // This allows the Drawer to go fullscreen when the window width is smaller than the width set on the drawer from the size prop
          minWidth: `${MIN_WIDTH}px`,
        }),
      ]}
      data-testid={dataTestId}
      confirmCloseMessages={confirmCloseMessages}
    >
      {children}
    </SailDrawer>
  );
};
